export default function AdminList() {
  return <>Admin-List</>;
}
